import type { TreeMapFilterItemProps } from "./tree-map-filter-item.type";
import type { MouseEvent } from "react";

import { Checkbox, Typography } from "antd";

import { isValidNumber } from "@/utilities/number";

import "./tree-map-filter-item.style.less";

const { Text } = Typography;

const TreeMapFilterItem = ({
  title,
  count,
  color,
  checked,
  disabled,
  onToggle,
}: TreeMapFilterItemProps) => {
  const text = (
    <>
      {color && (
        <span
          className="tree-map-filter-item-color"
          style={{ background: color }}
        />
      )}
      {title}
      {isValidNumber(count) && ` ${count}`}
    </>
  );

  const onClick = (e: MouseEvent<HTMLElement>) => {
    e.stopPropagation(); // prevent collapse
  };

  return (
    <div className="tree-map-filter-item">
      <Checkbox
        checked={checked}
        disabled={disabled}
        onClick={onClick}
        onChange={onToggle}
        classNames={{
          root: "tree-map-filter-item--root",
          label: "tree-map-filter-item--label",
          icon: "tree-map-filter-item--icon",
        }}
      >
        <Text onClick={onClick}>{text}</Text>
      </Checkbox>
    </div>
  );
};

export default TreeMapFilterItem;
